import * as tslib_1 from "tslib";
import { Action, Selector, State } from '@ngxs/store';
import { takeUntil, tap } from 'rxjs/operators';
import { FetchPerpetualLicenses } from './perpetual-licenses.actions';
import { Logout } from './auth.actions';
let PerpetualLicensesState = class PerpetualLicensesState {
    constructor(actions, perpetualLicensesRepository) {
        this.actions = actions;
        this.perpetualLicensesRepository = perpetualLicensesRepository;
    }
    static licenses(state) {
        return state.licenses;
    }
    fetchLicenses(ctx, action) {
        let request = this.perpetualLicensesRepository.listByAccountId(action.accountId)
            .pipe(tap(response => ctx.patchState({
            licenses: response.data.items
        })));
        if (action.cancellationToken) {
            request = request.pipe(takeUntil(action.cancellationToken));
        }
        return request;
    }
    logout(ctx, action) {
        ctx.patchState({
            licenses: [],
        });
    }
};
tslib_1.__decorate([
    Action(FetchPerpetualLicenses)
], PerpetualLicensesState.prototype, "fetchLicenses", null);
tslib_1.__decorate([
    Action(Logout)
], PerpetualLicensesState.prototype, "logout", null);
tslib_1.__decorate([
    Selector()
], PerpetualLicensesState, "licenses", null);
PerpetualLicensesState = tslib_1.__decorate([
    State({
        name: 'PerpetualLicenses',
        defaults: {
            licenses: [],
        }
    })
], PerpetualLicensesState);
export { PerpetualLicensesState };
